(() => {
  function getCard(cardEl) {
    return cardEl && cardEl.closest("[data-product-card]");
  }

  function getVariants(cardEl) {
    const script = cardEl.querySelector("script[data-variants-json]");
    if (!script) return [];
    try {
      const parsed = JSON.parse(script.textContent || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.warn("ACG: failed to parse variants JSON", e);
      return [];
    }
  }

  function normalize(v) {
    return (v || "").toString().trim().toLowerCase();
  }

  function setActiveSwatch(cardEl, activeBtn) {
    const all = cardEl.querySelectorAll("[data-swatch]");
    all.forEach((b) => b.classList.remove("is-active"));
    activeBtn.classList.add("is-active");
  }

  function prefetch(url) {
  if (!url) return;
  const img = new Image();
  img.decoding = "async";
  img.src = url;
}

document.addEventListener(
  "mouseenter",
  (e) => {
    const card = e.target.closest("[data-product-card]");
    if (!card || card.__acgPrefetched) return;

    const variants = (function getVariants(cardEl) {
      const script = cardEl.querySelector("script[data-variants-json]");
      if (!script) return [];
      try { return JSON.parse(script.textContent || "[]"); } catch { return []; }
    })(card);

    card.__acgPrefetched = true;
    variants.forEach((v) => v.img && prefetch(v.img));
  },
  true
);

  function findVariantForSwatch(variants, pos, val) {
    if (!variants?.length) return null;

    const key = pos === 1 ? "option1" : pos === 2 ? "option2" : pos === 3 ? "option3" : null;
    if (!key) return null;

    const target = normalize(val);

    // Prefer first variant that matches that option.
    // If you later add "available" into your JSON, you can prefer available here.
    return variants.find((v) => normalize(v[key]) === target) || null;
  }

  function swapCardImage(cardEl, variant) {
    if (!variant) return;

    const imgEl = cardEl.querySelector("img[data-card-image]");
    if (!imgEl) {
      console.warn("ACG: No img[data-card-image] found in card");
      return;
    }

    if (!variant.img) {
      // Variant exists but has no featured image assigned in Shopify
      console.log("ACG: matched variant has no img (no variant featured image assigned)", variant);
      return;
    }

    // Swap source
    imgEl.src = variant.img;

    // IMPORTANT: remove srcset so browser doesn't keep old responsive candidates
    imgEl.removeAttribute("srcset");

    // If you also output a srcset in liquid, we can apply it:
    if (variant.srcset) {
      imgEl.setAttribute("srcset", variant.srcset);
    }

    // Also update the wrapping link to include the variant (optional but nice)
    const mediaLink = cardEl.querySelector(".acg-card__media");
    if (mediaLink && variant.url) mediaLink.href = variant.url;

    // Update Buy link if you want it to go straight to that variant
    const buyLink = cardEl.querySelector("[data-acg-buy]");
    if (buyLink && variant.url) {
      if (buyLink.tagName === "A") buyLink.href = variant.url;
      buyLink.dataset.productUrl = variant.url;
    }
  }

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-swatch]");
    if (!btn) return;

    const card = getCard(btn);
    if (!card) return;

    e.preventDefault();

    const pos = parseInt(btn.getAttribute("data-option-position"), 10);
    const val = btn.getAttribute("data-option-value");

    const variants = getVariants(card);

    // Helpful debugging (leave for now)
    if (!variants.length || !pos || !val) {
      console.log("ACG: No variants / pos / val", {
        variantsCount: variants.length,
        pos,
        val,
      });
      return;
    }

    setActiveSwatch(card, btn);

    const match = findVariantForSwatch(variants, pos, val);

    console.log("ACG: Swatch clicked", { pos, val, match });

    swapCardImage(card, match);
  });
})();
